'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: don't rely on React.__spread!
if (typeof Object.assign !== 'function') {
  Object.assign = _react2.default.__spread;
}

exports.default = Object.assign;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.43/js/objectAssign.js
// module id = 103
// module chunks = 0